var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelfService = function SvgSelfService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.828,
    cy: 48.097,
    r: 10.696,
    transform: "rotate(-90 26.828 48.097)",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48.182 30.337 15.865 15.191v5.845L48.169 66.576",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m35.56 30.337 15.864 15.191v5.845L35.546 66.576M60.177 30.337l15.865 15.191v5.845L60.164 66.576",
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgSelfService;